import apiClient from "../../services/apiClient";

export async function checkStudentAPI(studentId, randomCode) {
  const response = await apiClient.get(
    `/api/v1/student/check?student_id=${studentId}&random_code=${randomCode}`
  );
  return { status: response.status, data: response.data };
}

export async function checkUserAPI(userId, randomCode) {
  const response = await apiClient.get(
    `/api/v1/user/check?user_id=${userId}&random_code=${randomCode}`
  );
  return { status: response.status, data: response.data };
}

export async function fetchStudentAPI(studentId, randomCode) {
  const response = await apiClient.get(
    `/api/v1/student/retrieve?id=${studentId}&random_code=${randomCode}`
  );
  return response.data;
}
